import { compose } from 'lodash/fp'
import React from 'react'
import withReduxForm from '../withReduxForm'
import DateInput, { IDateInputProps } from './DateInput'
import withCustomFormat from './withCustomFormat'
import withRedux from './withRedux'

const ConnectedDateInput: React.ComponentType<IDateInputProps> = compose(
  withReduxForm,
  withCustomFormat,
  withRedux,
)(DateInput)

export default ConnectedDateInput
export { DateInput }
